// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YlGX","title":"styles_title__1MGXO"};